//Returns distinct values of given array
export const getDistinctValues = (array) => {
    var distinctValues = [];
    for(var i = 0; i < array.length; i++) {
        if(!distinctValues.includes(array[i])) {
            distinctValues.push(array[i]);
        }
    }
    return distinctValues;
};




// WEBPACK FOOTER //
// ./src/utils/JSUtils.js